module.exports = __webpack_public_path__ + "static/img/1-1.0ca61bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/2/1-1.png
// module id = C32e
// module chunks = 0